import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './context/AuthContext';
import { SidebarProvider } from './context/SidebarContext';
import Layout from './components/Layout';
import LoginPage from './pages/LoginPage';
import AccessRestricted from './pages/AccessRestricted';
import TTDashboard from './pages/TTDashboard';
import TTMatches from './pages/TTMatches';
import TTMatchDetail from './pages/TTMatchDetail';
import Dashboard from './pages/Dashboard';
import PrematchSignals from './pages/PrematchSignals';
import LiveSignals from './pages/LiveSignals';
import Matches from './pages/Matches';
import MatchDetail from './pages/MatchDetail';
import Players from './pages/Players';
import PlayerDetail from './pages/PlayerDetail';
import Notifications from './pages/Notifications';
import Settings from './pages/Settings';
import ScreenshotCompare from './pages/ScreenshotCompare';
import BetTracking from './pages/BetTracking';
import AdminPanel from './pages/AdminPanel';
import AdminLLMCosts from './pages/AdminLLMCosts';
import AdminFeatureExplorer from './pages/AdminFeatureExplorer';
import AdminFeatureSnapshotCoverage from './pages/AdminFeatureSnapshotCoverage';
import AdminSetScoreEngine from './pages/AdminSetScoreEngine';
import ErrorLogs from './pages/ErrorLogs';
import TopPicks from './pages/TopPicks';
import ModelCompare from './pages/ModelCompare';
import PerformanceMonitor from './pages/PerformanceMonitor';
import PatternLab from './pages/PatternLab';
import AIAdvisorHistory from './pages/AIAdvisorHistory';
import './App.css';

function ProtectedRoute({ children }) {
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <div style={{
        minHeight: '100vh', display: 'flex', alignItems: 'center',
        justifyContent: 'center', background: '#0a0a0a',
      }}>
        <div style={{ color: '#10b981', fontSize: 16 }}>Loading...</div>
      </div>
    );
  }

  if (user === false) {
    return <Navigate to="/login" replace />;
  }

  return children;
}

function AppRoutes() {
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <div style={{
        minHeight: '100vh', display: 'flex', alignItems: 'center',
        justifyContent: 'center', background: '#0a0a0a',
      }}>
        <div style={{ color: '#10b981', fontSize: 16 }}>Loading...</div>
      </div>
    );
  }

  return (
    <Routes>
      <Route path="/login" element={
        user ? <Navigate to="/" replace /> : <LoginPage />
      } />
      <Route path="/restricted" element={<AccessRestricted />} />
      <Route path="/*" element={
        <ProtectedRoute>
          <SidebarProvider>
            <Layout>
              <Routes>
                <Route path="/" element={<TTDashboard />} />
                <Route path="/tt/top-picks" element={<TopPicks />} />
                <Route path="/tt/matches" element={<TTMatches />} />
                <Route path="/tt/matches/:matchId" element={<TTMatchDetail />} />
                <Route path="/legacy" element={<Dashboard />} />
                <Route path="/segnali-prematch" element={<PrematchSignals />} />
                <Route path="/segnali-live" element={<LiveSignals />} />
                <Route path="/incontri" element={<Matches />} />
                <Route path="/incontri/:id" element={<MatchDetail />} />
                <Route path="/giocatori" element={<Players />} />
                <Route path="/giocatori/:id" element={<PlayerDetail />} />
                <Route path="/notifiche" element={<Notifications />} />
                <Route path="/impostazioni" element={<Settings />} />
                <Route path="/confronta-quote" element={<ScreenshotCompare />} />
                <Route path="/bet-tracking" element={<BetTracking />} />
                <Route path="/admin" element={<AdminPanel />} />
                <Route path="/admin/llm-costs" element={<AdminLLMCosts />} />
                <Route path="/admin/feature-explorer" element={<AdminFeatureExplorer />} />
                <Route path="/admin/feature-snapshot-coverage" element={<AdminFeatureSnapshotCoverage />} />
                <Route path="/admin/setscore-engine" element={<AdminSetScoreEngine />} />
                <Route path="/admin/log-errori" element={<ErrorLogs />} />
                <Route path="/admin/model-compare" element={<ModelCompare />} />
                <Route path="/admin/performance" element={<PerformanceMonitor />} />
                <Route path="/pattern-lab" element={<PatternLab />} />
                <Route path="/ai-advisor" element={<AIAdvisorHistory />} />
              </Routes>
            </Layout>
          </SidebarProvider>
        </ProtectedRoute>
      } />
    </Routes>
  );
}

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <AppRoutes />
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
